var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ecgConversionFactor } from '@cardiacsense/cs-charts-module';
export var fakeEcgDataForProportionSign = function (scale, fwVersion) {
    var ecgConv = fwVersion ? ecgConversionFactor(fwVersion) : 0.0033;
    var h = scale === 1 ? 10000 + 2 / ecgConv : 11000;
    var fakeEcg = [];
    var fake = 0;
    for (var s = 0; s < 256; s++) {
        if (s === (11 * scale))
            fake = 10000;
        if (s === (26 * scale) - 1)
            fake = h;
        if (s === (51 * scale))
            fake = 10000;
        if (s === (65 * scale))
            fake = 0;
        fakeEcg.push(fake);
    }
    var empty256 = Array(256).fill('');
    var sign = {
        series: 0,
        ecg: fakeEcg,
        ecgPeaks: empty256,
        ecgPeakTypes: empty256,
        ecgHr: empty256,
        ecgNextHr: empty256
    };
    return sign;
};
var convertToCamelCase = function (str) { return str.replace(/_[a-z]/g, function (match) { return "".concat(match[1].toUpperCase()); }); };
export var convertKeysToCamelCase = function (obj) {
    var res = {};
    Object.keys(obj).forEach(function (key) {
        res[convertToCamelCase(key)] = obj[key];
    });
    return res;
};
export var convertConfigurationsToBooleans = function (app_config, compareConfig) {
    if (compareConfig === void 0) { compareConfig = 'off'; }
    var default_config = {
        pulse_rate: true,
        ppg_af: true,
        heart_rate: true,
        ecg_af: true,
        blood_pressure: true,
        weight: true,
        glucose: true,
        spo2: true,
        respiratory_rate: true,
        body_temp: true,
        pwv: true,
        pwv_weekly: true,
        hrv_pr: true,
        hrv_lfhf: true,
        sleep: true,
        steps: true,
        calories: true,
        medications: true,
        night_respiratory: true,
        detections: true,
        night_rsi: true,
    };
    var app_configuration_config = __assign({}, default_config);
    if (!app_config) {
        return default_config;
    }
    else {
        if (app_config.measurements) {
            var measurements = app_config.measurements;
            var measurements_config = {
                heart_rate: measurements.heart_rate !== compareConfig,
                body_temp: measurements.body_temp !== compareConfig,
                pulse_rate: measurements.pulse_rate !== compareConfig,
                respiratory_rate: measurements.respiratory_rate !== compareConfig,
                spo2: measurements.spo2 !== compareConfig,
                glucose: measurements.glucose !== compareConfig,
                weight: measurements.weight !== compareConfig,
                blood_pressure: measurements.blood_pressure !== compareConfig,
                pwv: measurements.pwv !== compareConfig,
                pwv_weekly: measurements.pwv !== compareConfig, //pwv_weekly is the same config as pwv
                hrv_pr: measurements.hrv_pr !== compareConfig,
                hrv_lfhf: measurements.hrv_lfhf !== compareConfig,
                sleep: measurements.sleep !== compareConfig,
                steps: measurements.steps !== compareConfig,
                calories: measurements.calories !== compareConfig,
                medications: measurements.medications !== compareConfig,
                night_respiratory: measurements.night_respiratory !== compareConfig,
                night_rsi: measurements.night_respiratory !== compareConfig, //night_rsi is indeed deppend on night_respiratory
                detections: measurements.detections !== compareConfig,
            };
            app_configuration_config = __assign(__assign({}, app_configuration_config), measurements_config);
        }
        if (app_config.alerts) {
            var alerts = app_config.alerts;
            var alerts_config = {
                ppg_af: alerts.af !== compareConfig,
                ecg_af: alerts.af !== compareConfig,
            };
            app_configuration_config = __assign(__assign({}, app_configuration_config), alerts_config);
        }
    }
    return app_configuration_config;
};
export var isNode = function (e) {
    return (typeof Node === "object" ? e instanceof Node :
        e && typeof e === "object" && typeof e.nodeType === "number" && typeof e.nodeName === "string");
};
export var fixNum = function (num, toFix) {
    if (isNaN(num))
        return num;
    var deleteZeros = Array(toFix).fill(0).join('');
    var fixedNumber = num.toFixed(toFix);
    fixedNumber = Number(("".concat(fixedNumber)).replace(".".concat(deleteZeros), ''));
    return fixedNumber;
};
//# sourceMappingURL=general-utils.js.map